import {
  MyAssetDetailPropsData,
  MyAssetDetailPropsMicrocopy,
} from '../MyAssetDetail/MyAssetDetail.types';

export type MyAssetsListPropsMicrocopy = {
  title: string;
  categories: string;
  sortBy: string;
  sortByPurchasedDate: string;
  sortByNameAsc: string;
  sortByNameDesc: string;
  noResults: string;
  resultsPerPage: string;
  update: string;
  categorySelected: string;
  categoryDeselected: string;
  detail: MyAssetDetailPropsMicrocopy;
};

export type MyAssetsCategory = {
  label: string;
  count: string;
};

export type MyAsset = MyAssetDetailPropsData & {
  productId: string;
  packageId?: string;
};

export type MyAssetsListPropsData = {
  results: string;
  categories: MyAssetsCategory[];
  selectedCategory?: string;
  assets: MyAsset[];
};

export type MyAssetsListPropsDataWithMicrocopy = MyAssetsListPropsData & {
  microcopy: MyAssetsListPropsMicrocopy;
};

export enum SortByOption {
  PURCHASED_DATE = 'purchased-date',
  NAME_ASC = 'name-asc',
  NAME_DESC = 'name-desc',
}

export const SORT_BY_DEFAULT = SortByOption.PURCHASED_DATE;

export enum FilterByResult {
  SMALL = 24,
  MEDIUM = 48,
  LARGE = 96,
}

export const FILTER_BY_RESULT_DEFAULT = FilterByResult.SMALL;

export type MyAssetsListPropsActions = {
  onFilterByCategory: (label: string) => void;
  onSortBy: (option: SortByOption) => void;
  onFilterByResult: (result: FilterByResult) => void;
  onOpenInUnity: (asset: MyAsset) => void;
  onSeeOwnedPackages: (asset: MyAsset) => void;
  onManageSeat: (asset: MyAsset) => void;
};

export type MyAssetsListProps = MyAssetsListPropsDataWithMicrocopy &
  MyAssetsListPropsActions & {
    variant?: 'default' | 'show-update';
    className?: string;
    isManageSeatEnabled?: boolean;
  };
